import TableList from "@components/templates/tablelist";
import { HttpRoleList, HttpDelRole } from "@/service/ucadm";
import compUpdate from "./update";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            // formData: {},
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },
    components: {
        compUpdate
    },
    methods: {
        ajaxRequest: HttpRoleList,
        handleOperates(params = "", type, batch) {
            if (batch) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning("请选择至少一条数据");
            }
            switch (type) {
                case "add":
                    this.operate = {
                        show: true,
                        type: 'add',
                        title: "添加角色",
                        component: "compUpdate",
                        width: 1000,
                        showFooter: false
                    };
                    break;
                case "edit":
                    this.operate = {
                        show: true,
                        params,
                        type: 'edit',
                        title: "编辑角色",
                        component: "compUpdate",
                        width: 1000,
                        showFooter: false
                    };
                    break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params },
                        title: "删除该角色",
                        ajaxRequest: HttpDelRole
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: "编辑",
                    show: true,
                    params: id,
                    operate: "edit"
                },
                {
                    label: "删除",
                    show: true,
                    params: id,
                    operate: "del"
                }
            ];
        }
    },
    computed: {
        ToolsData() {
            return [
                {
                    name: "添加角色",
                    operate: "add",
                    theme: "primary"
                }
            ];
        },
        SearchsData() {
            return [
                {
                    label: "角色名称",
                    tag: "vInput",
                    key: "CN_displayName",
                    show: true
                }
            ];
        },
        columns() {
            return [
                {
                    title: "操作",
                    width: 70,
                    render: this.getOperateNodes
                },
                {
                    title: "角色名称",
                    key: "displayName",
                    sortable: true
                },
                {
                    title: "是否全局角色",
                    key: "organizationId",
                    width: 100,
                    render: (h, { row }) => {
                        let text = <span class="color-error">是</span>;
                        row.organizationId === 0 ? text = <span class="color-error">是</span> : text = <span>否</span>
                        return <div>{text}</div>
                    }
                },
                {
                    title: "角色描述",
                    key: "description"
                },
                {
                    title: "更新时间",
                    key: "updatedAt"
                }
            ];
        }
    }
};
